import { connect } from 'react-redux';
import Notifications from 'views/notifications/Notifications';
import { notificationSettingRequest, updateNotificationSettingRequest } from 'store/actions/general.actions';
import { getSaving, getNotificationSetting, getUpdatedNotificationSetting } from 'store/selector/general.selector';

const mapDispatchToProps = {
  getSettingRequest: notificationSettingRequest,
  updateSetting: updateNotificationSettingRequest,
};

const mapStateToProps = (state: any) => {
  const saving = getSaving(state);
  const setting = getNotificationSetting(state);
  const settingSuccess = getUpdatedNotificationSetting(state);
  return {
    saving,
    setting,
    settingSuccess,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
